/** FI translations for Les Aiguilles Blanches */
const fi: Record<string, string> = {
  subtitle: "Rinnekonesimulaattori",
  startGame: "Aloita peli",
  resumeGame: "Jatka",
  newGame: "Uusi peli",
  // UNUSED continue: "Jatka",
  settings: "Asetukset",
  controls: "Ohjaus",
  changelog: "Uutuudet",
  howToPlay: "Peliohjeet",
  fullscreen: "Koko näyttö",
  fullscreenHint: "Paina F koko näytölle",
  exitFullscreen: "Poistu koko näytöstä",
  back: "Takaisin",
  backToGame: "Takaisin peliin",
  // UNUSED loading: "Ladataan...",
  inputKeyboard: "✓ Näppäimistö havaittu",
  inputKeyboardOff: "✗ Ei näppäimistöä",
  inputTouch: "✓ Kosketusnäyttö havaittu",
  inputTouchOff: "✗ Kosketusnäyttöä ei havaittu",
  inputGamepad: "✓ Peliohjain yhdistetty",
  inputGamepadOff: "✗ Ei peliohjainta",
  updateAvailable: "Uusi versio saatavilla — napauta ladataksesi uudelleen",
  madeIn: "Tehty ❄️:lla Savoie'ssa",
  feedback: "Anna palautetta",
  on: "✓ PÄÄLLÄ",
  off: "✗ POIS",
  zoneClosed: "🚫 ALUE SULJETTU",

  // Settings
  language: "Kieli",
  accessibility: "Esteettömyys",
  highContrast: "Korkea kontrasti",
  reducedMotion: "Vähennetty liike",
  showFps: "Näytä FPS",
  showDebug: "Virheenkorjaus",
  skiStyle: "Tyyli",
  skiTricks: "Temput",
  skiBestCombo: "Paras kombo",
  quitGame: "Lopeta peli",
  display: "Näyttö",
  displayWindowed: "Ikkuna",
  displayFullscreen: "Koko näyttö",
  displayBorderless: "Reunaton",
  colorblindMode: "Värisokeus",
  none: "Ei mitään",
  deuteranopia: "Deutan.",
  protanopia: "Protan.",
  tritanopia: "Tritan.",
  // UNUSED move: "Liiku",
  moveUp: "Ylös",
  moveDown: "Alas",
  moveLeft: "Vasen",
  moveRight: "Oikea",
  groom: "Tamppaa",
  winch: "Vinssi",
  pause: "Tauko",
  keyboard: "Näppäimistö",
  clickToRebind: "Klikkaa muuttaaksesi",
  pressKey: "Paina näppäintä...",
  pressGamepadButton: "Paina ohjaimen nappia...",
  noGamepad: "Ei peliohjain yhdistetty",
  gamepadButtons: "Ohjain",
  saved: "Tallennettu!",
  resetControls: "Palauta",
  controlsReset: "Ohjaus palautettu!",
  movementSensitivity: "Herkkyys",
  keyboardLayout: "Asettelu",
  customBindings: "Mukautettu",
  // UNUSED gamepadSupported: "Peliohjain OK",
  touch: "Kosketus",
  // UNUSED touchSupported: "Kosketus OK",
  noGamepadConnected: "Ei peliohjainta",
  gamepadDiagnostic: "Ohjaimen testi",
  connectGamepadDiag: "Yhdistä ohjain testataksesi",
  gamepadDiagButtons: "Painikkeet",
  gamepadDiagSticks: "Tatit",
  gamepadDiagTriggers: "Liipaimet",

  // Audio
  audio: "Ääni",
  masterVolume: "Äänenvoimakkuus",
  musicVolume: "Musiikki",
  sfxVolume: "Ääniefektit",
  engineVolume: "Moottori",
  voiceVolume: "Puhe",
  ambienceVolume: "Tunnelma",
  mute: "Mykistä",

  backgroundAudio: "Taustaääni",
  // Gameplay
  bonus: "Bonus",
  skiMode: "Laskettelutila",
  ski: "Suksi",
  snowboard: "Lumilauta",
  random: "Satunnainen",
  skiIt: "Laskemaan!",
  rideIt: "Laudalle!",
  skiAgain: "Laske uudestaan!",
  rideAgain: "Laske uudestaan!",
  skiRunSpeed: "Nopeus",
  skiRunTime: "Aika",
  skiRunGates: "Portit",

  // How to Play hints
  howToPlayMove: "{keys} tai nuolet liikkumiseen",
  howToPlayMoveTouch: "Käytä virtuaalista D-padia",
  howToPlayMoveGamepad: "Vasen tikku tai D-pad liikkumiseen",
  howToPlayMoveHybrid: "{keys}/nuolet tai kosketus-D-pad",
  howToPlayGroom: "{groomKey} tampataksesi lunta",
  howToPlayGroomTouch: "Pidä tampausnappia pohjassa",
  howToPlayGroomGamepad: "tampataksesi lunta",
  howToPlayGroomHybrid: "{groomKey} tai pidä tampausnappia pohjassa",
  howToPlayFuel: "Tarkkaile polttoainetta ja kestävyyttä!",
  howToPlayWinch: "{winchKey} ankkurin lähellä vinssiä varten",
  howToPlayWinchTouch: "Pidä vinssipainiketta ankkurin lähellä",
  howToPlayWinchGamepad: "ankkurin lähellä vinssiä varten",
  howToPlayWinchHybrid: "{winchKey} tai pidä vinssipainiketta ankkurin lähellä",

  // Winch
  winchSnapped: "💥 Kaapeli katkesi!",
  winchAttached: "🔗 Vinssi kiinnitetty! Pidä {winchKey} avustukseen.",
  winchActive: "VINSSI",
  // UNUSED winchHint: "Paina {winchKey} numeroidun ankkuritolpan lähellä käyttääksesi vinssiä",
  // UNUSED winchHintTouch: "Pidä 🔗 vinssille",
  // UNUSED accessPath: "Huoltotie",
  // UNUSED toPiste: "Rinteeseen",

  // Taunts - Cliff falls
  tauntCliff1: "9 tonnia rotkoon. Vakuutusyhtiö ilahtuu.",
  tauntCliff2: "Jean-Pierre sanoi 'älä liian lähelle reunaa!' Muistatko?",
  tauntCliff3: "Rinnepartio laskeutuu köysillä. Taas.",
  tauntCliff4: "Marie peruuttaa raclette-varauksesi tältä illalta.",
  tauntCliff5: "Thierry laskee jo korjauskustannuksia...",

  // Taunts - Fuel empty
  tauntFuel1: "Mittari oli punaisella 10 minuuttia. Mitä sinä katselit?",
  tauntFuel2: "Émilie kirjoitti 'TANKKAA' isoilla kirjaimilla taululle.",
  tauntFuel3: "Dieselilläkin on rajansa. Sinullakin, näemmä.",
  tauntFuel4: "Jean-Pierre huokaa. Hän lähettää Thierryn kanisterin kanssa.",
  tauntFuel5: "Aurinko nousee. Rinne on tamppaamatta. Hiihtäjät saapuvat.",

  // Taunts - Time limit
  tauntTime1: "Ensimmäinen tuolihissi 3... 2... 1... Myöhässä.",
  tauntTime2: "Hiihtäjät löytävät rinteesi. Kuoppainen. Jäinen. Mahtava.",
  tauntTime3: "Jean-Pierre katsoo kelloaan, sitten sinua, sitten kelloaan.",
  tauntTime4: "FIS ihmettelee miksi pujottelu on keitetty sopaksi.",
  tauntTime5: "Kuulet hiihto-opettajien selittävän asiakkaille, miksi se 'ei ole heidän syytään'.",

  // UNUSED paused: "Tauolla",
  resume: "Jatka",
  quitToMenu: "Valikkoon",
  levelComplete: "Rinne valmis!",
  levelFailed: "Rinne epäonnistui",
  tryAgain: "Yritä uudelleen",
  coverage: "Kattavuus",
  time: "Aika",
  // UNUSED rating: "Arvosana",
  nextLevel: "Seuraava rinne",
  // UNUSED replay: "Uusinta",
  // UNUSED pressContinue: "Paina välilyöntiä tai kosketa jatkaaksesi",
  pauseTitle: "⏸️ Tauko",
  restart: "Aloita alusta",
  skipRun: "Ohita lasku",
  newRun: "Uusi rinne",
  quit: "Lopeta",
  menu: "Valikko",
  levelSelect: "Valitse rinne",
  locked: "Suljettu",
   completeToUnlock: "Suorita {name} avataksesi",
  // UNUSED target: "Tavoite",
  tutorial: "Hiihtokoulu",
  timeUsed: "Käytetty aika",
  excellent: "Erinomaista!",
  good: "Hienoa!",
  passed: "Läpäisty",
  bonusFuel: "Polttoaine käytetty",
  bonusFlawless: "Ensimmäisellä yrityksellä",
  bonusSpeed: "Aika",
  bonusWinch: "Vinssinkäyttöä",
  bonusExplore: "Teitä tutkittu",
  bonusPrecision: "Tamppauksen laatu",
  retry: "Yritä uudelleen",
  gameComplete: "Peli läpäisty!",
  viewCredits: "Näytä kiitokset",
  creditsTitle: "Onnittelut!",
  creditsSubtitle: "Olet hallinnut Les Aiguilles Blanches'n",
  creditsCreatedBy: "Tekijä",
  creditsDevelopedWith: "Kehitetty käyttäen",
  creditsArtDirection: "Taiteellinen johto",
  creditsRetroInspiration: "Kunnianosoitus retroklassikoille kuten SkiFree",
  creditsInspiredBy: "Inspiraatio",
  creditsGroomers: "Savoien rinnekoneen kuljettajat",
  creditsDedication: "Yövuoroille, jotka valmistavat rinteet meidän nukkuessa",
  creditsThanks: "Kiitos pelaamisesta!",
  creditsSeeYou: "Nähdään rinteessä!",
  creditsLine: "Tule, poika. Aurinko nousee. Vuori on valmis.",
  playAgain: "Pelaa uudelleen",
  skipCredits: "Paina mitä tahansa ohittaaksesi",

  // Tutorial
  tutorialName: "Opastus - Ensiaskeleet",
  tutorialTask: "Opi tamppauksen perusteet",
  prologueLine: "Kello 4. Vuori on sinun. Töihin.",
  prologueSkip: "Paina jatkaaksesi",
  tutorialIntro: "Tervetuloa Les Aiguilles Blanches'iin!",
  skipTutorial: "⏭️ Ohitetaan opastus… Napauta toistaaksesi.",
  skipTutorialGamepad: "⏭️ Ohitetaan opastus… Paina nappia toistaaksesi.",
  tutorialWelcome: "🏔️ Jean-Pierre, rinnepäällikkö. Aja rinteessä — käytä {keys} tai ↑↓←→.",
  tutorialWelcomeTouch: "🏔️ Jean-Pierre, rinnepäällikkö. Aja rinteessä — käytä D-padia vasemmalla.",
  tutorialWelcomeGamepad: "🏔️ Jean-Pierre, rinnepäällikkö. Aja rinteessä — käytä vasenta tikkua tai D-padia.",
  // UNUSED     tutorialControls: "🎮 Ohjaa rinnekonetta {keys}-näppäimillä tai nuolilla ↑↓←→.",
  // UNUSED     tutorialControlsTouch: "🎮 Ohjaa rinnekonetta D-padilla ◀▲▼▶ vasemmalla.",
  // UNUSED     tutorialControlsGamepad: "🎮 Ohjaa rinnekonetta vasemmalla tikulla tai D-padilla.",
  // UNUSED     tutorialMove: "➡️ Kokeile! Aja rinteessä — kaikki valkoinen lumi pitää tampata.",
  // UNUSED     tutorialGroomIntro: "✅ Hienoa! Nyt opetellaan tamppaamaan.",
  tutorialGroomAction: "❄️ Pidä {groomKey} pohjassa ajaessasi tampataksesi lunta. Se tasoittuu heti.",
  tutorialGroomActionTouch: "❄️ Pidä oikealla olevaa tampausnappia pohjassa ajaessasi.",
  tutorialGroomActionGamepad: "❄️ Pidä {groomKey} pohjassa ajaessasi tampataksesi lunta. Se tasoittuu heti.",
  tutorialGroomGoal: "📊 Juuri niin! Tamppaa vähintään 60% ennen avaamista. Hiihtäjät tulevat!",
  // UNUSED   tutorialCoverage: "📊 Näetkö? Lumi tasoittuu! Jatka rinteen tampaamista.",
  // UNUSED   tutorialHUD: "📈 Katso mittaristoa ylhäällä: punainen palkki on polttoaine, vihreä kestävyys, valkoinen kattavuus. Kello tikittää!",
  // UNUSED   tutorialGoal: "🎯 Sinun täytyy tampata vähintään 60% rinteestä ennen avaamista. Hiihtäjät tulevat!",
  // UNUSED tutorialFuel: "⛽ Varoitus — ajaminen kuluttaa polttoainetta. Tehtävissä pysähdy tankkaamaan.",
  tutorialComplete: "🏆 Hyvin tehty! Perusasiat hallussa. Valmis ensimmäiseen oikeaan tehtävään vihreällä rinteellä?",

  level_marmottesName: "Vihreä rinne - Les Marmottes",
  level_marmottesTask: "Tamppaa aloittelijarinne",
  level_chamoisName: "Sininen rinne - Le Chamois",
  level_chamoisTask: "Tamppaa tehokkaasti ennen avausta",
  level_airZoneName: "Snowpark - Air Zone",
  level_airZoneTask: "Valmistele freestyle-rakenteet",
  level_aigleName: "Punainen rinne - L'Aigle",
  level_aigleTask: "Tamppaa jyrkkä maasto, hallitse polttoaine",
  level_glacierName: "Punainen rinne - Le Glacier",
  level_glacierTask: "Opi käyttämään vinssiä jyrkissä rinteissä",
  level_tubeName: "Half-pipe - Le Tube",
  level_tubeTask: "Huolla half-pipe kilpailua varten",
  level_verticaleName: "Musta rinne - La Verticale",
  level_verticaleTask: "Yöoperaatio vinssillä",
  level_colDangereuxName: "Lumivyöryalue - Col Dangereux",
  level_colDangereuxTask: "Valmistele korkean riskin alue",
  level_tempeteName: "Myrsky - Palautuminen",
  level_tempeteTask: "Raivaa rinteet myrskyn jälkeen",
  level_coupeDesAiguillesName: "Coupe des Aiguilles - FIS-finaali",
  level_coupeDesAiguillesTask: "Valmistele kaikki rinteet kilpailua varten",

  // Hazards
  cliffFall: "⚠️ VAROITUS! Putosit jyrkänteeltä! Tehtävä epäonnistui.",
  fuelEmpty: "⛽ POLTTOAINE LOPPU! Ei tippaa dieseliä jäljellä...",
  // UNUSED avalancheZone: "LUMIVYÖRYALUE",
  riskLevelHigh: "KORKEA",
  avalancheWarning: "⚠️ VAARA! Lumipeite on epävakaa! Poistu alueelta!",
  avalancheTrigger: "🏔️💨 LUMIVYÖRY LAUENNUT! Pakotietä ei ole!",
  steepWarning: "⚠️ JYRKKÄ RINNE! Käytä vinssiä ({winchKey}) tai liu'u!",
  steepWarningNoWinch: "⚠️ JYRKKÄ RINNE! Hidasta ja käytä huoltoteitä kiertääksesi!",
  tumble: "🔄 PYÖRÄHDYS! Rinnekone kaatui rinteessä!",

  // Taunts - Tumble
  tauntTumble1: "Vinssi ei ole koriste. Se on tällaisia rinteitä varten.",
  tauntTumble2: "Thierry tuijottaa vaurioita. Ei sano mitään. Se on pahempaa.",
  tauntTumble3: "Jean-Pierre näytti kuinka ankkuroidutaan. Nukuitko?",
  tauntTumble4: "PistenBully maksaa 400 000€. Siis, maksoi.",
  tauntTumble5: "Rinne tuntui hallittavalta? Rinnekone oli eri mieltä.",
  featureDestroyedKicker: 'Ajoit parkkielementin yli! Kikkeri on tuhottu.',
  featureDestroyedRail: 'Ajoit parkkielementin yli! Raili on tuhottu.',
  tauntFeature1: 'Tuon elementin rakentaminen vei kolme tuntia. Litistit sen kolmessa sekunnissa.',
  tauntFeature2: 'Émilie tulee puhumaan sinulle tuosta parkkielementistä.',
  tauntFeature3: 'Parkkitiimi katsoi sinun tuhoavan heidän mestariteoksensa.',
  tauntFeature4: 'Elementit ovat laskijoille, eivät rinnekoneille. Aja ympäri!',
  tauntFeature5: 'Yksi elementti vähemmän huomisen kisaan.',
  bonusPipeMastery: 'Halfpipen hallinta',

  // Taunts - Avalanche
  tauntAvalanche1: "Vuori antaa harvoin anteeksi. Ei antanut.",
  tauntAvalanche2: "Météo France sanoi riskiluokka 4. Luitko?",
  tauntAvalanche3: "Rinnepartio löytää koneen keväällä. Ehkä.",
  tauntAvalanche4: "Marie kuulee radiohälytyksen. Hän tietää jo että sinä se olit.",
  tauntAvalanche5: "Rinnepartio oli turvannut alueen. Sinä turvasit sen pois.",

  // Taunts - Ski wipeout (fun, self-deprecating)
  tauntSkiWipeout1: "Klassinen kaatuminen. Varusteet joka puolella, arvokkuus ei missään.",
  tauntSkiWipeout2: "Jyrkänne ei välittänyt hiihtotekniikastasi.",
  tauntSkiWipeout3: "Rinnepartio nauraa jo. He näkivät kaiken.",
  tauntSkiWipeout4: "Tätä saa kun hiihtää itse valmistamaansa rinnettä.",
  tauntSkiWipeout5: "Jopa vuorikauriit irvistivät tuota laskeutumista.",

  // Dialogues
  jeanPierreIntro: "Hyvin tehty tutoriaalissa. Nyt on totta — vihreä rinne, ajastimella ja polttoaineella.",
  level_marmottesMid: "Näetkö sen hohteen huipuilla? Ensivalo. Tämän työn paras hetki — vain sinä, kone ja heräävä vuori.",
  level_chamoisIntro: "Hei, olen Émilie — JP lähettää sinut siniselle. Näytä, että osaat muutakin kuin samettia vihreällä.",
  level_airZoneIntro: "Snowpark on MINUN aluettani — rakennetaan heille jotain mahtavaa! Jokaisen moduulin pitää olla täydellinen, laskijat luottavat meihin.",
  level_aigleIntro: "L'Aigle on vakavaa. Tarkkaile polttoainetta. Huoltotiet vievät takaisin ylös — etsi kelta-mustaisia tolppia.",
  level_glacierIntro: "Hei, olen Thierry — turvallisuusvastaava. Le Glacier on jyrkkä. Olen tarkistanut jokaisen ankkurin. Paina {winchKey} tolpan lähellä kiinnittääksesi vinssin — ja ole kiltti, älä päästä irti.",
  level_glacierIntroTouch: "Hei, olen Thierry — turvallisuusvastaava. Le Glacier on jyrkkä. Olen tarkistanut jokaisen ankkurin. Paina vinssinappia tolpan lähellä — ja ole kiltti, älä päästä irti.",
  level_tubeIntro: "Huomenna on kilpailu Tubessa! Puhtaat seinät, terävä reuna ja nolla kohoumaa.",
  level_verticaleIntro: "Yöoperaatio La Verticalella: jyrkkä rinne, vaaralliset reunat. Vinssi on pakollinen — käytä 3 ankkuria ja pysy linjassa.",
  level_colDangereuxIntro: "Korkea lumivyöryriski solassa — noudatamme lumivyöryturvaprotokollaa. Pysy pois kuormitetuilta alueilta ja kunnioita rajoja.",
  level_tempeteIntro: "Myrsky on ohi. Ota vin chaud — tässä kestää!",
  level_coupeDesAiguillesIntro: "Tämä on se suuri ilta. FIS tarkastaa huomenna. Jokaisen rinteen pitää olla täydellinen — näytä mitä olet oppinut.",
  marieWelcome: "Tule lämmittelemään Chez Marie'hen. Hyvää tartiflette'a!",
  marieIntro: "Hei! Olen Marie, pyöritän ravintolaa rinteen yläpäässä. Piipahtele milloin vain — lämmin ateria tekee ihmeitä!",

  // Changelog
  changelog_20260219_date: "19. helmikuuta 2026",
  changelog_20260219: "🎬 Prologi uusille pelaajille\n📖 Yksinkertaistettu opastus\n🌦️ Satunnainen valikon sää\n🔗 Jaettavat päivän laskut\n🎥 Elokuvamainen lopputeksti",
  changelog_20260222_date: "22. helmikuuta 2026",
  changelog_20260222: "🚩 Pujotteluporttien tasapainotus\n💬 Palautepainike",
  changelog_20260223_date: "23. helmikuuta 2026",
  changelog_20260223: "📲 Asenna laitteellesi ja pelaa offline",
  changelog_20260220_date: "20. helmikuuta 2026",
  changelog_20260220: "🗺️ Rinnekartta\n🎿 Hiihtokeskussanasto",
  changelog_20260217_date: "17. helmikuuta 2026",
  changelog_20260217: "🏔️ Seitsemän rinnemuotoa\n🎯 Kenttävaihtelu lisätty\n⚡ Sulavampi laskettelu",
  changelog_20260216_date: "16. helmikuuta 2026",
  changelog_20260216: "🎲 Päivän rinteet",
  changelog_20260215_date: "15. helmikuuta 2026",
  changelog_20260215: "⚡ Yörenderöinnin uudistus\n📱 Hiihtotilan kosketuspainikkeet\n⌨️ Näppäimistön tunnistus",
  changelog_20260214_date: "14. helmikuuta 2026",
  changelog_20260214: "🎪 Temppupisteet & kombot\n🏂 Muna-asento & halfpipe-fysiikka\n👁️ Parempi rinnekontrasti\n📱 Automaattinen kunnostus vinssillä (kosketus)\n♿ Korkean kontrastin tila",
  changelog_20260213_date: "13. helmikuuta 2026",
  changelog_20260213: "🚩 Pujotteluportit\n🏔️ Mäkihypyt\n⚡ Suorituskyky parannettu\n🎹 Nokturni-pianomusiikki\n🔊 Moottorin äänenvoimakkuus säädettävä",
  changelog_20260212_date: "12. helmikuuta 2026",
  changelog_20260212: "📋 Rinnekartta\n🔗 Katkeava vinssikaapeli\n🕹️ Ohjaindiagnostiikka\n🍽️ Marien ruoat\n❄️ Kylmäaltistus",
  changelog_20260211_date: "11. helmikuuta 2026",
changelog_20260211: "⛷️ Laskettelulasku tamppauksen jälkeen\n🎯 Tamppauksen laatu\n🏔️ Värikoodatut jyrkät vyöhykkeet\n🏗️ Parkki ja trikit",
  changelog_20260210_date: "10. helmikuuta 2026",
  changelog_20260210: "🎵 Musiikki ja äänitehosteet\n🔈 Äänenvoimakkuusasetukset\n⏱️ Automaattisesti kalibroidut rinneajat\n⏭️ Ohita opastus\n🏔️ Lumivyöryalueet uudistettu",
  changelog_20260209_date: "9. helmikuuta 2026",
  changelog_20260209: "🏔️ Alppilaiset voitto/häviönäytöt\n❄️ Myrskyn lumikertymä\n🏆 Virheetön bonus\n🔊 Sää- ja eläinambienssit",
  changelog_20260208_date: "8. helmikuuta 2026",
  changelog_20260208: "📊 Uudistettu mittaristo\n🏔️ Le Glacier ja Coupe des Aiguilles\n🦅 Alppieläimet\n🎨 Hahmomuotokuvat\n🎮 Näppäimistö- ja ohjainnavigaatio",
  changelog_20260207_date: "7. helmikuuta 2026",
  changelog_20260207: "🎨 Retrokäyttöliittymä\n🎯 Bonustavoitteet\n🕹️ Ohjainnappien uudelleenmääritys\n🎮 Ohjainvalikkonavigointi",
  changelog_20260206_date: "6. helmikuuta 2026",
  changelog_20260206: "🛤️ Ajettavat huoltotiet\n🕹️ Virtuaalinen joystick\n🌍 5 täydellistä kieltä",
  changelog_20260205_date: "5. helmikuuta 2026",
  changelog_20260205: "🏔️ Kalliojyrkänteet\n🌙 Yöajovalot\n🔗 Vinssimekaniikka\n⌨️ Näppäimistönavigaatio",
  changelog_20260204_date: "4. helmikuuta 2026",
  changelog_20260204: "🎮 Peliohjaintuki\n📱 Kosketusohjaus\n💪 Kestävyys\n💾 Tallenna edistyminen\n♿ Esteettömyys",
  changelog_20260203_date: "3. helmikuuta 2026",
  changelog_20260203: "🚜 Julkaisu: 9 rinnettä, hiihtokoulu\n❄️ Tamppaus, polttoaine, lumivyöryt\n🏆 Kiitokset ja eteneminen",
  // Key names
  key_space: "VÄLILYÖNTI",
  key_shift: "SHIFT",
  key_ctrl: "CTRL",
  key_alt: "ALT",
  key_enter: "ENTER",
  key_tab: "TAB",
  key_esc: "ESC",
  key_del: "DEL",
  dailyRuns: "Päivän rinteet",
  dailyRuns_dailyShift: "Päivävuoro",
  dailyRuns_randomRun: "Satunnainen ajo",
  dailyRuns_rank: "Sijoitus",
  dailyRuns_seed: "Siemen",
  // UNUSED   dailyRuns_start: "Aloita sopimus",
  dailyRuns_locked: "Läpäise kaikki rinteet avataksesi",
  dailyRuns_lockedShared: "Suorita kaikki rinteet avataksesi päivittäiset kierrokset ja pelataksesi tämän jaetun rinteen",
  // UNUSED   dailyRun_levelName: "Sopimus",
  dailyRun_levelTask: "Kunnostakaa rinne tavoitepeittoon",
  dailyRuns_briefing: "Toimeksianto",
  dailyRuns_target: "Tavoite",
  dailyRuns_timeLimit: "Aika",
  dailyRuns_weather_clear: "Selkeä sää",
  dailyRuns_weather_light_snow: "Heikko lumisade",
  dailyRuns_weather_storm: "Myrskyolosuhteet",
  dailyRuns_night: "Yövuoro",
  dailyRuns_day: "Päivävuoro",
  rank_green: "Vihreä",
  rank_blue: "Sininen",
  rank_red: "Punainen",
  rank_black: "Musta",
  rank_park: "Park",
  share: "Jaa",
  copied: "Linkki kopioitu!",
  playSharedSeed: "Jaettu kierros",
  dailyRunBriefingJP: "Rinne pitää olla valmis ennen hissien avaamista. Töihin.",
  dailyRunBriefingThierry: "Ole varovainen tuolla — jyrkkiä osuuksia ja epävakaata lunta. Pysy valppaana.",
  dailyRunBriefingMarie: "Tästä tulee kylmä yö. Pistäydy ravintolassa lämmittelemässä, jos tarvitsee.",
  dailyRunBriefingEmilie: "Taas yksi rinne. Yritäpä päihittää aikani!"
};

export default fi;
